import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function maxDateValidator(maxDate: Date): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const inputDate = new Date(control.value);

      if (isNaN(inputDate.getTime())) {
        return { invalidDate: true };
      }

      return inputDate > maxDate ? { maxDateExceeded: true } : null;
    };
}

export function minDateValidator(minDate: Date): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const inputDate = new Date(control.value);

        if (isNaN(inputDate.getTime())) {
            return { invalidDate: true }; 
        }
        
        return inputDate < minDate ? { minDateExceeded: true } : null;
    };
}